/**
 * Dispatcher for the attachment preview modal. Any component that wants to
 * open `AttachmentPreviewModal` fires `openAttachmentPreview(id)`; `Workspace`
 * subscribes via `subscribeAttachmentPreview` and owns the modal mount.
 */

const ATTACHMENT_PREVIEW_EVENT = 'dragonvault:attachment-preview';

export function openAttachmentPreview(id: string): void {
  window.dispatchEvent(
    new CustomEvent<{ id: string }>(ATTACHMENT_PREVIEW_EVENT, { detail: { id } }),
  );
}

export function subscribeAttachmentPreview(handler: (id: string) => void): () => void {
  const fn = (e: Event) => {
    const d = (e as CustomEvent<{ id: string }>).detail;
    if (d?.id) handler(d.id);
  };
  window.addEventListener(ATTACHMENT_PREVIEW_EVENT, fn);
  return () => window.removeEventListener(ATTACHMENT_PREVIEW_EVENT, fn);
}
